// One illustration per alert type (public/illustrations/alerts, made by
// ops/scripts/gen_finder_illustrations.py --set alerts, light + dark).
// They replaced the line icons (owner, 2026-10-07). A plain module with
// no "use client", so the server-rendered alerts landing can read it
// too (AlertPanel re-exports it for the signed-in page).
export const TYPE_ART = {
  search: "searches", watch: "watchlist", residence: "residences",
  auction: "auctions", property: "property", digest: "summary",
  // Their own scenes since the owner's review of 2026-10-20: the monthly
  // developers' bulletin, and new residences apart from the digest.
  bulletin: "developers", new_residences: "new_residences",
} as const;
export type AlertKind = keyof typeof TYPE_ART;
